export enum CustomizableReportType {
  Predefined = 'predefined',
  Custom = 'custom',
}
